import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { LangProvider } from "@/context/LangContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import QRManage from "@/pages/QRManage";
import SOS from "@/pages/SOS";
import Family from "@/pages/Family";
import Vehicle from "@/pages/Vehicle";
import LostFound from "@/pages/LostFound";
import Community from "@/pages/Community";
import AIAssistant from "@/pages/AIAssistant";
import Admin from "@/pages/Admin";
import PublicQR from "@/pages/PublicQR";
import ResponderPortal from "@/pages/ResponderPortal";

const RESPONDER_ROLES = ["volunteer", "police", "hospital", "ambulance", "ngo", "admin", "super_admin"];

function App() {
  return (
    <ThemeProvider>
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster richColors position="top-right" />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/scan/:qrId" element={<PublicQR />} />
              <Route path="/app" element={<ProtectedRoute><AppShell><Dashboard /></AppShell></ProtectedRoute>} />
              <Route path="/app/qr" element={<ProtectedRoute><AppShell><QRManage /></AppShell></ProtectedRoute>} />
              <Route path="/app/sos" element={<ProtectedRoute><AppShell><SOS /></AppShell></ProtectedRoute>} />
              <Route path="/app/family" element={<ProtectedRoute><AppShell><Family /></AppShell></ProtectedRoute>} />
              <Route path="/app/vehicle" element={<ProtectedRoute><AppShell><Vehicle /></AppShell></ProtectedRoute>} />
              <Route path="/app/lost-found" element={<ProtectedRoute><AppShell><LostFound /></AppShell></ProtectedRoute>} />
              <Route path="/app/community" element={<ProtectedRoute><AppShell><Community /></AppShell></ProtectedRoute>} />
              <Route path="/app/ai" element={<ProtectedRoute><AppShell><AIAssistant /></AppShell></ProtectedRoute>} />
              <Route path="/app/admin" element={<ProtectedRoute roles={["admin", "super_admin"]}><AppShell><Admin /></AppShell></ProtectedRoute>} />
              <Route path="/portal/responder" element={<ProtectedRoute roles={RESPONDER_ROLES}><ResponderPortal /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LangProvider>
    </ThemeProvider>
  );
}

export default App;
